import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {
    AboutYourselfSection,
    IntroducerSection,
    LitigationSection,
    PEPSection,
    PrivateAccount,
    PrivateMasterAccountOptions,
    PrivateAccountAttachments

} from '../entity/private-account.i';
import {EmploymentInformationModel} from '../../../+applications/new/detail/+details/private/employment.information/employment-information.i';
import {FundsInformationModel} from '../../components/funds.information/funds-information.i';
import {ApplicantInformationModel, UploadedFileResponse} from '../entity';


@Injectable()
export class PrivateAccountsService {

    constructor(private _http: Http) {
    }

    getPrivateAccount(id: number): Observable<PrivateAccount> {
        return this._http.get('/api/backoffice/private_accounts/' + id)
            .map(response => response.json())
    }

    getPrivateAccountAttachments(id: number): Observable<PrivateAccountAttachments> {
        return this._http.get(`/api/backoffice/private_accounts/${id}`)
            .map(response => response.json());
    }

    updatePersonInformation(id: number, model: AboutYourselfSection): Observable<AboutYourselfSection> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/usage-and-referral`, model)
            .map(response => response.json());
    }

    updateApplicantInformation(id: number, model: ApplicantInformationModel): Observable<ApplicantInformationModel> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/applicant`, model)
            .map(response => response.json());
    }

    updateRegisteredClientApplicantInformation(id: number, model: ApplicantInformationModel): Observable<ApplicantInformationModel> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/applicant/registered`, model)
            .map(response => response.json());
    }

    updateEmploymentInformation(id: number, model: EmploymentInformationModel): Observable<EmploymentInformationModel> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/employment`, model)
            .map(response => response.json());
    }

    updateFundsInformation(id: number, model: FundsInformationModel): Observable<FundsInformationModel> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/funds`, model)
            .map(response => response.json());
    }

    updateIntroducerInformation(id: number, model: IntroducerSection): Observable<IntroducerSection> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/introducer`, model)
            .map(response => response.json());
    }

    updateLitigationInformation(id: number, model: LitigationSection): Observable<LitigationSection> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/litigation`, model)
            .map(response => response.json());
    }

    updateMasterAccountCurrencyInformation(id: number, model: PrivateMasterAccountOptions): Observable<PrivateMasterAccountOptions> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/account-currency`, model)
            .map(response => response.json());
    }

    updatePositionInformation(id: number, model: PEPSection): Observable<PEPSection> {
        return this._http.patch(`/api/backoffice/private_accounts/${id}/position`, model)
            .map(response => response.json());
    }

    upload(file: File, type: string): Observable<UploadedFileResponse> {
        const formData: FormData = new FormData();
        formData.append('file', file, file.name.replace(/\.[^/.]+$/, ''));

        return this._http.post(`/api/backoffice/files?type=${type}`, formData)
            .map(response => response.json());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/api/service/private-accounts.service.ts